module.exports = __webpack_public_path__ + "img/prev.a6018464.png";